import Iconify from "@/components/ui/Iconify";
import StaticVideoPreview from "@/components/ui/StaticVideoPreview";
import { useTranslations } from "@/lib/static-intl";
import { getMediaRecordPath, getMediaRecordUrl } from "@/utils/media";
import Image from "next/image";

const PDW_HomeVisitorMediaGridSection = ({
  placeMedia,
  setCurrentTab,
  openPlaceMediaSlider,
}) => {
  const t = useTranslations("places.place_details_window");
  
  if (placeMedia?.length === 0) return null;

  const previewMedia = placeMedia?.slice(0, 6) || [];
  const sliderPaths = previewMedia.map((media) => getMediaRecordPath(media));

  return (
    <div className="w-full flex flex-col gap-3 pt-2">
      <div className="w-fit flex items-center gap-2">
        <span className="font-semibold text-lg dark:text-white">
          {t("visitor photos and videos")}
        </span>
        <span className="font-bold text-lg text-black/30 dark:text-white/50">
          {placeMedia?.length}
        </span>
      </div>
      {placeMedia?.length > 0 ? (
        <div className="w-full rounded-xl overflow-hidden grid grid-cols-3 gap-0.5">
          {previewMedia.map((_m, i) => {
            const mediaUrl = getMediaRecordUrl(_m);
            const imageUrl =
              getMediaRecordUrl(_m, { variant: "thumbnail" }) ||
              mediaUrl ||
              "/person.png";
            const posterUrl =
              _m?.thumbnailPath || _m?.placeholderPath || _m?.placeholder
                ? getMediaRecordUrl(_m, { variant: "thumbnail" })
                : undefined;

            return (
              <div
                key={i}
                className="w-full aspect-square relative"
                onClick={() => openPlaceMediaSlider(sliderPaths, i)}
              >
                {_m?.mediaType?.includes("video") ? (
                  <StaticVideoPreview
                    src={mediaUrl}
                    poster={posterUrl}
                    className="w-full h-full object-cover rounded-xl border dark:border-brown"
                  />
                ) : (
                  <Image
                    src={imageUrl}
                    alt="sample"
                    width={640}
                    height={640}
                    sizes="(max-width: 640px) 33vw, (max-width: 1280px) 33vw, 360px"
                    quality={90}
                    className="w-full h-full object-cover rounded-xl border dark:border-brown"
                  />
                )}
                <div className="absolute cursor-pointer top-0 left-0 w-full h-full bg-black/0 hover:bg-black/20 transition ease-in-out duration-200 rounded-xl" />
                {_m?.mediaType?.includes("video") && (
                  <div className="absolute top-2 right-2 w-5 h-5 bg-black/10 backdrop-blur rounded-full z-10">
                    <Iconify
                      icon={"mynaui:play-solid"}
                      className={"!text-white"}
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="flex flex-col gap-2 items-center justify-center h-[300px]">
          <Image
            src={"/no-data.png"}
            alt="no-data"
            width={50}
            height={50}
            className="object-contain"
          />
          <span className="text-xs text-black/30 dark:text-white/30">
            {t("no visitor photos")}
          </span>
        </div>
      )}

      <div className="w-full flex items-center">
        <div className="h-[1px] w-full bg-black/[0.08] dark:bg-white/[0.12]" />
        <button
          type="button"
          className="w-fit py-1.5 px-4 rounded-full bg-black/5 dark:bg-white/5 text-black/70 dark:text-white/70 text-sm flex items-center text-nowrap"
          onClick={() => setCurrentTab("Photos")}
        >
          {t("view visitor photos and videos")}
          <Iconify
            icon={"lsicon:right-outline"}
            className={"!text-inherit !mt-0.5"}
          />
        </button>
        <div className="h-[1px] w-full bg-black/[0.08] dark:bg-white/[0.12]" />
      </div>
    </div>
  );
};

export default PDW_HomeVisitorMediaGridSection;
